/** @jsx jsx */
import { jsx } from '@emotion/core'
import { observer } from 'mobx-react'
import React, { Fragment } from 'react'
import useRootStore from '@store/useRootStore'
import { useOnMount } from '@utils/reactExt'
import { ListView } from 'antd-mobile'
import { Schema$UserPickExtend } from '@interface/user-pick'
import * as _ from 'lodash'
import { AdvEmpty } from '@components/AdvEmpty'
import { EMPTY_ICON } from '@constants/index'
import { UserPickItem } from '@views/Home/UserPick/Components/UserPickItem'

const dataSource = new ListView.DataSource({
  rowHasChanged: (row1, row2) => row1 !== row2,
})

interface UserPickActivityProps {
  baseMonth?: string
}

export const UserPickActivity: React.FC<UserPickActivityProps> = observer((
  props: UserPickActivityProps,
) => {
  const { userPickStore } = useRootStore()
  const { userPickMine, userPickMineHasMore } = userPickStore

  useOnMount(() => {
    fetch(true)
  })

  const fetch = (reset = false) => {
    userPickStore.fetchUserPickMine(reset, props?.baseMonth).catch(console.error)
  }

  const renderHeader = (): React.ReactElement => {
    return <Fragment/>
  }

  const renderRow = (row: Schema$UserPickExtend): React.ReactElement => {
    return <UserPickItem userPick={row} showMatchInfoSimple/>
  }

  const renderFooter = (): React.ReactElement => {
    let footer
    if (_.size(userPickMine) > 0) {
      footer = <Fragment/>
    } else {
      footer = <AdvEmpty ico={EMPTY_ICON.USER_PICK_ACTIVITY}/>
    }
    return <div css={{ textAlign: 'center' }}>{footer}</div>
  }

  const endReachedHandler = () => {
    if (userPickMineHasMore) {
      fetch()
    }
  }

  return (
    <ListView
      css={{ height: 'calc(100% - 40px)' }}
      dataSource={dataSource.cloneWithRows(userPickMine ?? [])}
      renderHeader={renderHeader}
      renderRow={renderRow}
      scrollRenderAheadDistance={500}
      renderFooter={renderFooter}
      onEndReached={endReachedHandler}
      onEndReachedThreshold={10}
      initialListSize={9}
      pageSize={9}
    />
  )
})
